import { DeleteOutline } from '@material-ui/icons'
import { deleteBoMItem } from '../../store/asyncActions/deleteBoMItem'
import { BomItemMenuItem } from './BomItemMenuItem'

export const DeleteMenuItem = ({
  bomItemId,
  onClose,
}: {
  bomItemId: string
  onClose?: () => void
}) => {
  return (
    <BomItemMenuItem
      disableIfNotEditable
      action={deleteBoMItem}
      actionParams={{ bomItemId }}
      primaryTextTranslationKey="project:delete-item"
      secondaryTextTranslationKey="project:delete-item-description"
      icon={<DeleteOutline />}
      onClose={onClose}
      closeOnClick
    />
  )
}
